<script setup lang="ts">
import { NarrowedPremium, PolicyType } from "@/entities/premium";
import PremiumLayout from "../PremiumLayout.vue";
import CompanyLogo from "../Shared/CompanyLogo.vue";
import PeriodicAmount from "../Shared/PeriodicAmount.vue";
import AnnualIncome from "../Shared/AnnualIncome.vue";
import { PaymentFrequency } from "@/stores/pensionOptions";

defineProps<{
    premium: NarrowedPremium<PolicyType.IndicativeAMS>;
    paymentFrequency: PaymentFrequency;
}>();
</script>

<template>
    <PremiumLayout>
        <template #first>
            <CompanyLogo :company-slug="premium.company.slug" />
            <PeriodicAmount
                :total-annual-pension="premium.policy.totalAnnualPension"
                :frequency="paymentFrequency"
            />
        </template>
        <template #second>
            <PeriodicAmount
                v-if="paymentFrequency === PaymentFrequency.Yearly"
                :total-annual-pension="premium.policy.totalAnnualPension"
                :frequency="paymentFrequency"
            />
            <AnnualIncome
                v-else
                :total-annual-pension="premium.policy.totalAnnualPension"
            />
        </template>
    </PremiumLayout>
</template>

<style scoped></style>
